/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, KeyboardAvoidingView } from 'react-native';
import * as Yup from 'yup';

import { buttonFloating, buttonRounded } from '@/assets/styles/buttonStyles';
import Colors from '@global/colors';
import { isWeb, isIos } from '@global/screens';

import SociollaText from '@components/sociolla/SociollaText';
import ModalTopRounded from '@components/modal/ModalTopRounded';
import {
  SociollaInput,
  SociollaForm,
  SociollaSubmitButton,
} from '@components/sociolla/form';
import PropTypes from 'prop-types';

const propTypes = {
  onSubmit: PropTypes.func,
  show: PropTypes.bool,
  onClose: PropTypes.func,
};

const ModalExport = (props) => {
  const buttonWidth = isWeb ? 150 : '100%';

  const handleSubmit = (data) => props.onSubmit(data.email);

  return (
    <KeyboardAvoidingView behavior={isIos ? 'padding' : undefined}>
      <ModalTopRounded
        visible={props.show}
        fullPage={isWeb ? true : false}
        animationType={isWeb ? 'fade' : 'slide'}
        maxWidth={isWeb ? 500 : '100%'}
        onClose={props.onClose}
        title="Export Loyalty Point"
        noTranslate={true}>
        <SociollaForm
          initialValues={{ email: '' }}
          onSubmit={handleSubmit}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .required('Email is required')
              .email('Must be a valid email')
              .label('Email'),
          })}>
          <View style={{ width: '100%', paddingHorizontal: 16 }}>
            {/* <SociollaText style={{ fontSize: 14, color: Colors.black3, marginBottom: 12 }}>Export this file:</SociollaText>
						<SociollaText style={{ fontSize: 14, color: Colors.blue8, marginBottom: 20 }}>Loyalty Points Jan 2022.xlxs</SociollaText> */}
            <SociollaInput label={'Enter email'} name="email" />
            <View
              style={[
                isWeb ? { padding: 15, marginTop: 10 } : buttonFloating,
                isWeb
                  ? { justifyContent: 'center', alignItems: 'center' }
                  : {
                      marginTop: 20,
                      padding: 0,
                      paddingTop: 15,
                      justifyContent: 'center',
                      position: 'relative',
                      elevation: 0,
                    },
                { width: '100%', bottom: 0 },
              ]}>
              <SociollaSubmitButton
                buttonStyle={{
                  ...buttonRounded,
                  width: buttonWidth,
                  ...(isWeb ? { marginHorizontal: 10 } : {}),
                }}
                title={
                  <SociollaText
                    type="bold"
                    style={{
                      fontSize: 14,
                      letterSpacing: 0.5,
                      color: Colors.white,
                      width: '100%',
                      textAlign: 'center',
                    }}>
                    Send Email
                  </SociollaText>
                }
              />
            </View>
          </View>
        </SociollaForm>
      </ModalTopRounded>
    </KeyboardAvoidingView>
  );
};

ModalExport.propTypes = propTypes;

export default ModalExport;
